<div class="content-section" [ngClass]="{ 'expand' : layoutService.expandedMenu }">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
  <div class="title-div">
    <div class="col p-0 d-flex justify-content-between align-items-center">
      <div class="col-11 p-0">
        <h2 class="background_title">{{ 'CHECK.HYGIENE_CHECK_EDITOR' | translate }}</h2>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="page-content-2">
      <hygiene-check-editor></hygiene-check-editor>
    </div>
  </div>
</div>